<template>
    <div class="action-photo">
        <div class="section-photos">
            <div class="timestamp" v-if="me">{{ message.created_at | formatDate('A h:mm') }}</div>
            <PhotoLayout v-if="message.mtype === 'photo'" :user="content" :image="imageUrl" @seeProfile="seeProfile" />
            <ProfilePhotoLayout
                v-else-if="message.mtype === 'profile-photo'"
                @click="onClickImage"
                :message="message"
            />
            <MultiPhotoLayout
                v-else
                @click="onClickImage"
                @seeProfile="seeProfile"
                :message="message"
                :user="content"
            />
            <div class="timestamp" v-if="!me && message.mtype !== 'multi-photo'">
                {{ message.created_at | formatDate('A h:mm') }}
            </div>
        </div>
    </div>
</template>

<script>
import MultiPhotoLayout from './MultiPhotoLayout'
import ProfilePhotoLayout from './ProfilePhotoLayout'
import PhotoLayout from './PhotoLayout'
import userService from '@/services/user'

export default {
    name: 'ActionPhoto',
    props: ['message'],
    components: { MultiPhotoLayout, ProfilePhotoLayout, PhotoLayout },
    watch: {
        content(newVal) {
            if (newVal) this.imageUrl = newVal.url
        },
    },
    computed: {
        me() {
            return this.message.user_id === this.$store.getters.me.id
        },
        content() {
            return this.$mustParse(this.message.content)
        },
        photos() {
            const messages = (this.chat || {}).$$messages
            let photos = []
            const photoMessages = (messages || []).filter(m => m.mtype.includes('photo')) || []
            photoMessages.forEach(m => {
                const c = this.$mustParse(m.content)
                if (c.url) photos.push(c.url)
                if (c.urls) photos = photos.concat(c.urls.reverse())
            })

            return photos.reverse()
        },
        chat() {
            return this.$store.getters.chat
        },
    },
    data: () => ({
        imageUrl: null,
    }),
    mounted() {
        this.imageUrl = this.content.url
    },
    methods: {
        onClickImage(pivotImage) {
            if (this.content.show_photo === false) {
                this.$toast.error('탈퇴 혹은 휴면했거나 활동이 정지된 회원입니다.')
                return
            }

            let selectedIndex
            this.photos.forEach((photo, idx) => {
                if (photo === pivotImage) selectedIndex = idx
            })

            this.$modal.images({
                images: this.photos,
                selectedIndex,
            })
        },
        getUserDetail() {
            return userService.detail(this.content.source_id)
        },
        async seeProfile() {
            if (this.content.show_photo === false) {
                this.$toast.error('탈퇴 혹은 휴면했거나 활동이 정지된 회원입니다.')
                return
            }
            const photos = () => {
                let photos = []
                if (this.content.url) {
                    photos.push(this.content.url)
                }

                if (this.content.urls) {
                    photos = photos.concat(this.content.urls)
                }

                return photos.map(p => ({ url: p }))
            }

            try {
                this.$stackRouter.push({
                    name: 'UserDetailPage',
                    props: {
                        userId: this.content.source_id,
                        photos: photos(),
                    },
                })
            } catch (e) {
                this.$toast.error(e.data)
            }
        },
    },
}
</script>
